// Phase 1 (ngUpgrade) — the modern-Angular NgModule that hosts the legacy app.
//
// This NgModule pulls in @angular/upgrade's UpgradeModule and, in ngDoBootstrap,
// hands control of the existing AngularJS `UmsApp` module to Angular. After this
// runs, both frameworks are live in the same page: AngularJS keeps rendering the
// app exactly as before, while Angular is bootstrapped and ready to host migrated
// components/services in later phases.

import { NgModule } from '@angular/core';
import type { DoBootstrap } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
// Phase 2: importing the hybrid also side-effect-registers the AngularJS `ui.router.upgrade`
// bridge module that UmsApp depends on.
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
// Phase 4.1: native Angular component states, routed by the hybrid router into the ng1
// parents' <ui-view>. APP_STATES aggregates every migrated feature's states (see ng/app.routes.ts).
import { APP_STATES } from './ng/app.routes';
// Phase 3: HttpClient + the ported secret-key interceptor.
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { secretKeyInterceptor } from './ng/interceptors/secret-key.interceptor';
// AngularJS services bridged UP into Angular DI (md5, $uibModal, …) — mirror of downgrades.ts.
import { UPGRADE_PROVIDERS } from './ng/upgrades';

@NgModule({
    // Phase 4.1: forRoot registers all migrated ng2 component states (the rest of the
    // ~178 states are still AngularJS, declared in configs/states.js).
    imports: [BrowserModule, UpgradeModule, UIRouterUpgradeModule.forRoot({ states: APP_STATES })],
    providers: [
        provideHttpClient(withInterceptors([secretKeyInterceptor])),
        ...UPGRADE_PROVIDERS,
    ],
})
export class AppModule implements DoBootstrap {
    constructor(private upgrade: UpgradeModule) {}

    ngDoBootstrap() {
        // Bootstrap the legacy AngularJS app under Angular's control. Replaces the
        // old `ng-app="UmsApp"` auto-bootstrap (removed from index.html).
        this.upgrade.bootstrap(document.body, ['UmsApp']);
    }
}
